import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53e68f9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "content_list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "content_list_item_name" }

import { ref } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
        show: {
            type: Boolean,
            required: true
        }
    },
  emits: ['close', 'value'],
  setup(__props, { emit }) {

const props: any = __props

    let list = ref([
        { name: '合格', id: '0' },
        { name: '不良', id: '1' },
        { name: '报废', id: '2' }
    ])

    // 返回上一页带参数
    const jump = (item: any) => {
        emit('value', item)
    }

    

    

    // 关闭回调
    const close = () => {
        emit('close')
    }

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: props.show,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((props.show) = $event)),
    "close-on-click-overlay": false,
    position: "bottom",
    style: { height: '60%' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "close",
          onClick: close
        }, [
          _createVNode(_component_van_icon, {
            name: "arrow-down",
            size: "30",
            color: "#ffffff"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "content_list_item",
              key: i,
              onClick: ($event: any) => (jump(item))
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1)
            ], 8, _hoisted_4))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})